(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["variant-add-on-products"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('variant-add-on-products')) {
    customElements.define(
      'variant-add-on-products',
      class VariantAddOnProducts extends HTMLElement {
        connectedCallback() {
          this.form = document.getElementById(this.dataset.formId);
          this.onChange = this.updateDynamicCheckout.bind(this);
          this.onSubmit = this.prepareCartItems.bind(this);
          this.onVariantChange = this.updateForVariant.bind(this);

          this.addEventListener('change', this.onChange);
          this.form?.addEventListener('submit', this.onSubmit, true);

          if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            this.unsubscribeVariant = subscribe(PUB_SUB_EVENTS.variantChange, this.onVariantChange);
          }
        }

        disconnectedCallback() {
          this.removeEventListener('change', this.onChange);
          this.form?.removeEventListener('submit', this.onSubmit, true);
          this.unsubscribeVariant?.();
        }

        updateForVariant(event) {
          const data = event?.data;
          if (String(data?.sectionId) !== String(this.dataset.sectionId) || !data.html) return;
          const source = data.html.getElementById(this.id);
          this.innerHTML = source?.innerHTML || '';
          this.hidden = !source || source.hidden;
          this.updateDynamicCheckout();
        }

        updateDynamicCheckout() {
          const hasSelectedAddOn = Boolean(this.querySelector('[data-add-on-variant]:checked'));
          const sleeveStylePicker = this.querySelector('.sleeve-style-picker');
          const hasSelectedSleeveStyle = Boolean(this.querySelector('[data-sleeve-style]:checked'));
          const sleeveStyleError = this.querySelector('[data-sleeve-style-error]');
          if (sleeveStyleError && hasSelectedSleeveStyle) sleeveStyleError.hidden = true;
          const dynamicCheckout = this.form?.querySelector('.shopify-payment-button');
          if (dynamicCheckout) {
            dynamicCheckout.hidden = hasSelectedAddOn || (sleeveStylePicker && !hasSelectedSleeveStyle);
          }
        }

        prepareCartItems(event) {
          const sleeveStylePicker = this.querySelector('.sleeve-style-picker');
          const selectedSleeveStyle = this.querySelector('[data-sleeve-style]:checked');
          const sleeveStyleError = this.querySelector('[data-sleeve-style-error]');

          if (sleeveStylePicker && !selectedSleeveStyle) {
            event.preventDefault();
            event.stopImmediatePropagation();
            if (sleeveStyleError) sleeveStyleError.hidden = false;
            return;
          }

          if (sleeveStyleError) sleeveStyleError.hidden = true;

          const selectedAddOns = Array.from(this.querySelectorAll('[data-add-on-variant]:checked'));
          if (!this.form) return;

          const temporaryFields = [];

          // Re-submit the selected style as a temporary hidden field so the
          // property is always present in Shopify's FormData payload.
          const sleeveStyleName = selectedSleeveStyle?.getAttribute('name');
          if (selectedSleeveStyle && sleeveStyleName) {
            selectedSleeveStyle.removeAttribute('name');

            const sleeveStyleProperty = document.createElement('input');
            sleeveStyleProperty.type = 'hidden';
            sleeveStyleProperty.name = 'properties[Sleeve Style]';
            sleeveStyleProperty.value = selectedSleeveStyle.value;
            this.form.appendChild(sleeveStyleProperty);
            temporaryFields.push(sleeveStyleProperty);
          }

          selectedAddOns.forEach((checkbox) => {
            const addOnId = document.createElement('input');
            addOnId.type = 'hidden';
            addOnId.name = 'iznik_add_on_id';
            addOnId.value = checkbox.value;
            this.form.appendChild(addOnId);
            temporaryFields.push(addOnId);

            const mainProductAddOnProperty = document.createElement('input');
            mainProductAddOnProperty.type = 'hidden';
            mainProductAddOnProperty.name = `properties[${checkbox.dataset.addOnPropertyName}]`;
            mainProductAddOnProperty.value = checkbox.dataset.addOnPropertyValue;
            this.form.appendChild(mainProductAddOnProperty);
            temporaryFields.push(mainProductAddOnProperty);
          });

          setTimeout(() => {
            temporaryFields.forEach((field) => field.remove());
            if (selectedSleeveStyle && sleeveStyleName) {
              selectedSleeveStyle.setAttribute('name', sleeveStyleName);
            }
          });
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
